import { render, staticRenderFns } from "./DataTableProviders.vue?vue&type=template&id=7cad6dd4&"
import script from "./DataTableProviders.vue?vue&type=script&lang=js&"
export * from "./DataTableProviders.vue?vue&type=script&lang=js&"
import style0 from "./DataTableProviders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports